"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParserMap = void 0;
exports.Parsers = Parsers;
var _ChileAdditonalPlanParser = require("./chile/ChileAdditonalPlanParser");
var _ChilePlanCardParser = require("./chile/ChilePlanCardParser");
var _PeruPlanCardParser = require("./peru/PeruPlanCardParser");
var _ChileComparisonParser = require("./chile/ChileComparisonParser");
var _PeruComparisonParser = require("./peru/PeruComparisonParser");
var _ChileRecommendationSummaryParser = _interopRequireDefault(require("./chile/ChileRecommendationSummaryParser"));
var _PeruRecommendationSummaryParser = _interopRequireDefault(require("./peru/PeruRecommendationSummaryParser"));
var _MaacBusinessSolutionCardParser = require("./maac/MaacBusinessSolutionCardParser");
var _MaacComparisonParser = require("./maac/MaacComparisonParser");
var _AdditionalPlanParser = require("./generic/AdditionalPlanParser");
var _BusinessSolutionCardParser = require("./generic/BusinessSolutionCardParser");
var _ComparisonParser = require("./generic/ComparisonParser");
var _PlanCardParser = require("./generic/PlanCardParser");
var _RecommendationSummaryParser = require("./generic/RecommendationSummaryParser");
var _ChileTaggingParser = require("./chile/ChileTaggingParser");
var _PeruTaggingParser = require("./peru/PeruTaggingParser");
var _TaggingParser = require("./generic/TaggingParser");
var _HandsetParser = require("./generic/HandsetParser");
var _ChileHandsetParser = require("./chile/ChileHandsetParser");
var _PaymentOptionsParser = require("./generic/PaymentOptionsParser");
var _ChilePaymentOptionsParser = require("./chile/ChilePaymentOptionsParser");
var _PeruPaymentOptionsParser = require("./peru/PeruPaymentOptionsParser");
var _CookieParser = require("./generic/CookieParser");
var _CookieParser2 = require("./de/CookieParser.de");
var _JourneyParser = require("./generic/JourneyParser");
var _ChileJourneyParser = require("./chile/ChileJourneyParser");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ParserMap = {
  generic: {
    AdditionalPlanParser: _AdditionalPlanParser.AdditionalPlanParser,
    BusinessSolutionCardParser: _BusinessSolutionCardParser.BusinessSolutionCardParser,
    ComparisonParser: _ComparisonParser.ComparisonParser,
    PlanCardParser: _PlanCardParser.PlanCardParser,
    RecommendationSummaryParser: _RecommendationSummaryParser.RecommendationSummaryParser,
    HandsetParser: _HandsetParser.HandsetParser,
    PaymentOptionsParser: _PaymentOptionsParser.PaymentOptionsParser,
    CookieParser: _CookieParser.CookieParser,
    JourneyParser: _JourneyParser.JourneyParser
  },
  gr: {
    HandsetParser: _HandsetParser.HandsetParser,
    TaggingParser: _TaggingParser.TaggingParser,
    ComparisonParser: _ComparisonParser.ComparisonParser,
    JourneyParser: _JourneyParser.JourneyParser
  },
  // it: {},
  // ie: {},
  sa: {
    TaggingParser: _TaggingParser.TaggingParser,
    HandsetParser: _HandsetParser.HandsetParser,
    ComparisonParser: _ComparisonParser.ComparisonParser,
    JourneyParser: _JourneyParser.JourneyParser
  },
  demo: {
    AdditionalPlanParser: _AdditionalPlanParser.AdditionalPlanParser,
    BusinessSolutionCardParser: _BusinessSolutionCardParser.BusinessSolutionCardParser,
    ComparisonParser: _ComparisonParser.ComparisonParser,
    PlanCardParser: _PlanCardParser.PlanCardParser,
    RecommendationSummaryParser: _RecommendationSummaryParser.RecommendationSummaryParser,
    HandsetParser: _HandsetParser.HandsetParser,
    TaggingParser: _TaggingParser.TaggingParser,
    CookieParser: _CookieParser.CookieParser,
    JourneyParser: _JourneyParser.JourneyParser
  },
  maac_ie: {
    BusinessSolutionCardParser: _MaacBusinessSolutionCardParser.MaacBusinessSolutionCardParser,
    ComparisonParser: _MaacComparisonParser.MaacComparisonParser,
    HandsetParser: _HandsetParser.HandsetParser,
    TaggingParser: _TaggingParser.TaggingParser,
    JourneyParser: _JourneyParser.JourneyParser
  },
  cl: {
    PlanCardParser: _ChilePlanCardParser.ChilePlanCardParser,
    AdditionalPlanParser: _ChileAdditonalPlanParser.ChileAdditionalPlanParser,
    ComparisonParser: _ChileComparisonParser.ChileComparisonParser,
    RecommendationSummaryParser: _ChileRecommendationSummaryParser.default,
    TaggingParser: _ChileTaggingParser.ChileTaggingParser,
    HandsetParser: _ChileHandsetParser.ChileHandsetParser,
    PaymentOptionsParser: _ChilePaymentOptionsParser.ChilePaymentOptionsParser,
    JourneyParser: _ChileJourneyParser.ChileJourneyParser
  },
  pe: {
    PlanCardParser: _PeruPlanCardParser.PeruPlanCardParser,
    ComparisonParser: _PeruComparisonParser.PeruComparisonParser,
    RecommendationSummaryParser: _PeruRecommendationSummaryParser.default,
    TaggingParser: _PeruTaggingParser.PeruTaggingParser,
    HandsetParser: _HandsetParser.HandsetParser,
    AdditionalPlanParser: _AdditionalPlanParser.AdditionalPlanParser,
    PaymentOptionsParser: _PeruPaymentOptionsParser.PeruPaymentOptionsParser,
    JourneyParser: _JourneyParser.JourneyParser
  },
  de: {
    ComparisonParser: _ComparisonParser.ComparisonParser,
    HandsetParser: _HandsetParser.HandsetParser,
    TaggingParser: _TaggingParser.TaggingParser,
    CookieParser: _CookieParser2.CookieParserDE,
    JourneyParser: _JourneyParser.JourneyParser
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.ParserMap = ParserMap;
function Parsers(tenant) {
  return ParserMap[tenant];
}